/** Shared `@page` / body rules for Management `react-to-print` exports. */
export const MANAGEMENT_PRINT_PAGE_STYLE = `
@media print {
  @page {
    size: auto;
    margin: 12mm;
  }
  html, body {
    height: initial !important;
    overflow: initial !important;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
  [data-testid="management-print-pdf"] {
    display: none !important;
  }
}
`;
